module.exports = __webpack_public_path__ + "fonts/VetoSansCond-CondLight_1.35622a4c.ttf";